define(function (require) {
    "use strict";

    var template = require("personalization-web-agent-templates/widget-templates/widget-edit/widgetParametersEdit.tmpl");

    var Config = require("personalization-web-agent-config/config.json");

    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var Singleselect = require("ui/singleselect-new/Singleselect");

    var WidgetParametersItemView = require("personalization-web-agent-views/widget-views/widget-edit/WidgetParametersItemView");
    var WidgetParametersModel = require("personalization-web-agent-models/WidgetParametersModel");

    var WidgetParametersEditView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetParametersEditView = Marionette.CompositeView.extend({
            className:"widget-edit",
            template: template,
            itemView: WidgetParametersItemView,
            itemViewContainer: ".edit-params-collection-container",
            ui:{
                "editContainer": ".edit-params-container",
                "cancelButton": ".edit-params-cancel",
                "saveButton": ".edit-params-save",
                "paramInputField": ".edit-params-add-input",
                "paramSelectField": ".edit-params-add-select",
                "addButton": ".edit-params-add-button"
            },
            uiComponents: {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK_NIGHT
                    },
                    events:{
                        "click": "_onCancelClick"
                    }
                },
                saveButton:{
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSaveClick"
                    }
                },
                paramInputField: {
                    type: InputField,
                    options:{
                        permutation:InputField.Permutation.P,
                        theme: InputField.THEME.NIGHT,
                        el:"view.ui.paramInputField",
                        maxLength: Config.iFrameWidget.widgetParamNameMaxLength,
                        placeholder: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.userParam.placeholder")
                    }
                },
                paramSelectField: {
                    type: Singleselect,
                    options: "_getSingleSelectOptions"
                },
                addButton:{
                    type: Button,
                    options: {
                        el: "view.ui.addButton",
                        permutation: Button.PERMUTATION.BTN_PLUS_NIGHT
                    },
                    events: {
                        "click": "_onAddParamsButtonClick"
                    }
                }
            },
            events: {
                "click .edit-params-close-btn": "_onCloseButtonClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize: function (options) {
                LEPersonalization.logger.info("Initializing WidgetParametersEditView", "WidgetParametersEditView:initialize");
                this.vent = options.vent;
                this.systemParamsItems = options.systemParamsItems;
                this.paramsMap = options.paramsMap;

                this.addCustomFields = options.addCustomFields;
            },

            itemViewOptions: function () {
                return {
                    addCustomFields: this.addCustomFields,
                    paramsMap: this.paramsMap
                };
            },

            onRender: function () {
                LEPersonalization.logger.debug("Rendering WidgetParametersEditView", "WidgetParametersEditView:onRender");
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetParametersEditView", "WidgetParametersEditView:onClose");
            },

            /************************** private functions *****************************************************/

            _getSingleSelectOptions: function(){
                var options = {
                    container: "view.ui.paramSelectField",
                    permutation: Singleselect.PERMUTATION.P,
                    theme: Singleselect.THEME.NIGHT,
                    errorPosition: Singleselect.ERROR_POSITION.RIGHT,
                    inputField: {
                        placeholder: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.systemParam.placeholder")
                    },
                    items : "view.systemParamsItems"
                };

                //Adding the custom variable for legacy customers
                if (this.addCustomFields){
                    options.list = {
                        noItems: {
                            value: LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.systemParam.create.new"),
                            enabled: true,
                            visible: true
                        }
                    };
                }

                return options;
            },

            _onAddParamsButtonClick: function(){

                //check if no items value added for legacy customers
                var userDefinedParam = this.uiComponents.paramInputField.getValue();
                var selectedSystemParam = this.uiComponents.paramSelectField.getSelectedItem();

                if (selectedSystemParam === Singleselect.NO_ITEM_SELECTED){
                    if (this.addCustomFields ){
                        selectedSystemParam = { id: this.uiComponents.paramSelectField.getInputValue() };
                    } else {
                        selectedSystemParam = { id: null };
                    }
                }

                var widgetParametersModel = new WidgetParametersModel({name: userDefinedParam, value: selectedSystemParam.id});

                var errorObject = widgetParametersModel.validate();

                //checks that the parameter is in the list, for legacy customers we don't need to check this because they
                //are allowed to add custom parameters
                var userParamInCollection = this.collection.findWhere({name: userDefinedParam});
                if(!userParamInCollection && _.isEmpty(errorObject)){
                    this.collection.add(widgetParametersModel);
                    this._resetUserSelection();
                    return true;
                }

                if(userParamInCollection){ //name already in collection
                    this.uiComponents.paramInputField.setError(true, LE.translator.translate("LEPersonalization.webAgent.widget.widgetEdit.paramsEdit.errors.name.taken"));
                }

                if(!_.isEmpty(errorObject)){ //model validation errors
                    this._onValidatedInvalid(errorObject);
                }

                return false;
            },

            _onValidatedInvalid:function (errors) {
                if (_.has(errors, WidgetParametersModel.KEYS.NAME)) {
                    this.uiComponents.paramInputField.setError(true, LE.translator.translate(errors[WidgetParametersModel.KEYS.NAME]));
                }
                if (_.has(errors, WidgetParametersModel.KEYS.VALUE)) {
                    this.uiComponents.paramSelectField.setError(true, LE.translator.translate(errors[WidgetParametersModel.KEYS.VALUE]));
                }
            },

            _resetUserSelection: function(){
                this.uiComponents.paramSelectField.clearInputValue();
                this.uiComponents.paramInputField.setValue("");
            },

            _onCancelClick: function(){
                this.vent.trigger("widget-edit-params:cancel");
            },

            _onSaveClick: function(){
                var userDefinedParam = this.uiComponents.paramInputField.getValue();
                var selectedSystemParam = this.uiComponents.paramSelectField.getSelectedItem();

                if(userDefinedParam || (selectedSystemParam && selectedSystemParam !== Singleselect.NO_ITEM_SELECTED)) {
                    var paramAdded = this._onAddParamsButtonClick();
                    if (paramAdded){
                        this._triggerSaveEvent();
                    }
                }
                else {
                    this._triggerSaveEvent();
                }
            },

            _triggerSaveEvent: function(){
                this.vent.trigger("widget-edit-params:save", {parametersCollection: this.collection});
            },

            _onCloseButtonClick: function(){
                this.vent.trigger("widget-edit-params:cancel");
            }
        });
    });
    return WidgetParametersEditView;
});

